import socket from './socket';

const inviteOrganizationMember = (organizationId, data, headers) =>
  socket.post(`/organizations/${organizationId}/invite`, data, headers);

const syncOrganizationFromClerk = (organizationId, headers) =>
  socket.post(`/organizations/${organizationId}/sync-from-clerk`, undefined, headers);

const removeOrganizationMember = (organizationId, userId, headers) =>
  socket.delete(`/organizations/${organizationId}/members/${userId}`, undefined, headers);

export default {
  inviteOrganizationMember,
  syncOrganizationFromClerk,
  removeOrganizationMember,
};
